import { createAction } from 'redux-act';
// check in check out save
const checkInCheckOutRequest = createAction('CHECK_IN_CEHCK_OUT_REQUEST', data => data);
const checkInCheckOutSuccess = createAction('CHECK_IN_CEHCK_OUT_SUCCESS', data => data);
const checkInCheckOutError = createAction('CHECK_IN_CEHCK_OUT_ERROR');

//get check in check out
const getCheckInCheckOutRequest = createAction('GET_CHECK_IN_CEHCK_OUT_REQUEST', data => data);
const getCheckInCheckOutSuccess = createAction('GET_CHECK_IN_CEHCK_OUT_SUCCESS', data => data);
const getCheckInCheckOutError = createAction('GET_CHECK_IN_CEHCK_OUT_ERROR');

//get Attendance Summary
const getAttendanceSummaryRequest = createAction('GET_ATTENDANCE_SUMMARY_REQUEST', data => data);
const getAttendanceSummarySuccess = createAction('GET_ATTENDANCE_SUMMARY_SUCCESS', data => data);
const getAttendanceSummaryError = createAction('GET_ATTENDANCE_SUMMARY_ERROR');

//get Attendance
const getMonthlyAttendanceRequest = createAction('GET_ATTENDANCE_REQUEST', data => data);
const getMonthlyAttendanceSuccess = createAction('GET_ATTENDANCE_SUCCESS', data => data);
const getMonthlyAttendanceError = createAction('GET_ATTENDANCE_ERROR');

//Get Attendance DashBoard
const getAttendanceDashBoardRequest = createAction('GET_ATTENDANCE_DASHBOARD_REQUEST', data => data);
const getAttendanceDashBoardSuccess = createAction('GET_ATTENDANCE_DASHBOARD_SUCCESS', data => data);
const getAttendanceDashBoardError = createAction('GET_ATTENDANCE_DASHBOARD_ERROR');

const getCorrectionNotificationRequest = createAction('GET_CORRECTION_NOTIFICATION_REQUEST', data => data);
const getCorrectionNotificationSuccess = createAction('GET_CORRECTION_NOTIFICATION_SUCCESS', data => data);
const getCorrectionNotificationError = createAction('GET_CORRECTION_NOTIFICATION_ERROR');

const attendanceLockRequest = createAction('ATTENDANCE_LOCK_REQUEST', data => data);
const attendanceLockSuccess = createAction('ATTENDANCE_LOCK_SUCCESS', data => data);
const attendanceLockError = createAction('ATTENDANCE_LOCK_ERROR');

const getAttendanceLockRequest = createAction('GET_ATTENDANCE_LOCK_REQUEST', data => data);
const getAttendanceLockSuccess = createAction('GET_ATTENDANCE_LOCK_SUCCESS', data => data);
const getAttendanceLockError = createAction('GET_ATTENDANCE_LOCK_ERROR');

const updateAttendanceLockRequest = createAction('UPDATE_ATTENDANCE_LOCK_REQUEST', data => data);
const updateAttendanceLockSuccess = createAction('UPDATE_ATTENDANCE_LOCK_SUCCESS', data => data);
const updateAttendanceLockError = createAction('UPDATE_ATTENDANCE_LOCK_ERROR');



// clear existing Designation action
const handleClearAttendanceDashboardStore = createAction('HANDLE_CLEAR_CHECK_IN_CEHCK_OUT_STORE',data => data);

export default {
    checkInCheckOutRequest,
    checkInCheckOutSuccess,
    checkInCheckOutError,

    getCheckInCheckOutRequest,
    getCheckInCheckOutSuccess,
    getCheckInCheckOutError,

    getAttendanceSummaryRequest,
    getAttendanceSummarySuccess,
    getAttendanceSummaryError,

    getMonthlyAttendanceRequest,
    getMonthlyAttendanceSuccess,
    getMonthlyAttendanceError,

    getAttendanceDashBoardRequest,
    getAttendanceDashBoardSuccess,
    getAttendanceDashBoardError,

    getCorrectionNotificationRequest,
    getCorrectionNotificationSuccess,
    getCorrectionNotificationError,

    attendanceLockRequest,
    attendanceLockSuccess,
    attendanceLockError,

    getAttendanceLockRequest,
    getAttendanceLockSuccess,
    getAttendanceLockError,
    
    updateAttendanceLockRequest,
    updateAttendanceLockSuccess,
    updateAttendanceLockError,

    handleClearAttendanceDashboardStore,
}